import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
var _class;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import Modal from '../Modal';
import { Dialog, DialogTitle, DialogFooter, DialogButton, DialogContent } from '../Dialog';
import ConfirmDialogState from './ConfirmDialogState';
export { default as ConfirmDialogState } from './ConfirmDialogState';

/**
 Usage:

  View:

  <ConfirmDialog state={myStore.myConfirm} title="Do stuff?">
    Do you <strong>REALLY</strong> want to unsubscribe from Cat Fancy?
  </ConfirmDialog>

  Store/state

  this.myConfirm = new ConfirmDialogState();

  ...

  const confirmed = await this.myConfirm.show();
  if (confirmed) ...

 */

/**
 * Confirmation dialog. Give it a title, content, and you're set!
 * Use the ConfirmDialogState to manage it.
 */
var ConfirmDialog = observer(_class = /*#__PURE__*/function (_React$Component) {
  function ConfirmDialog() {
    _classCallCheck(this, ConfirmDialog);
    return _callSuper(this, ConfirmDialog, arguments);
  }
  _inherits(ConfirmDialog, _React$Component);
  return _createClass(ConfirmDialog, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        state = _this$props.state,
        title = _this$props.title,
        yes = _this$props.yes,
        no = _this$props.no,
        danger = _this$props.danger,
        disabled = _this$props.disabled,
        children = _this$props.children,
        position = _this$props.position,
        bordered = _this$props.bordered,
        _this$props$compact = _this$props.compact,
        compact = _this$props$compact === void 0 ? false : _this$props$compact,
        _this$props$hideOverl = _this$props.hideOverlayDismiss,
        hideOverlayDismiss = _this$props$hideOverl === void 0 ? false : _this$props$hideOverl;
      var yesButtonProps = _defineProperty({}, danger ? 'danger' : 'primary', true);
      var dataTest = this.props['data-test'] || 'test' + Math.random();
      return /*#__PURE__*/React.createElement(Modal, {
        isOpened: state.isOpened,
        onRequestClose: state.no,
        position: position,
        compact: compact,
        hideOverlayDismiss: hideOverlayDismiss
      }, /*#__PURE__*/React.createElement(Dialog, {
        compact: compact
      }, title && /*#__PURE__*/React.createElement(DialogTitle, {
        "data-test": "".concat(dataTest, "-title")
      }, title), /*#__PURE__*/React.createElement(DialogContent, null, children), /*#__PURE__*/React.createElement(DialogFooter, {
        bordered: bordered
      }, /*#__PURE__*/React.createElement(DialogButton, {
        onClick: state.no,
        disabled: disabled,
        "data-test": "".concat(dataTest, "-no")
      }, no), /*#__PURE__*/React.createElement(DialogButton, _extends({}, yesButtonProps, {
        shadow: true,
        onClick: state.yes,
        disabled: disabled,
        "data-test": "".concat(dataTest, "-yes")
      }), yes))));
    }
  }]);
}(React.Component)) || _class;
export { ConfirmDialog as default };
ConfirmDialog.propTypes = {
  state: PropTypes.instanceOf(ConfirmDialogState),
  title: PropTypes.string,
  yes: PropTypes.string,
  no: PropTypes.string,
  danger: PropTypes.bool,
  disabled: PropTypes.bool,
  children: PropTypes.node,
  position: PropTypes.string
};
ConfirmDialog.defaultProps = {
  yes: 'Ok',
  no: 'Cancel',
  title: 'Confirm',
  danger: false,
  disabled: false
};
//# sourceMappingURL=index.js.map
